/** Weather frame chrome. Place, condition and day names come from the agent. */
export default {
  noWeather: "No weather data",
  highTemp: "H:{temp}°",
  lowTemp: "L:{temp}°",
} as const;
